// src/views/condominos/AniversariantesModal.jsx
import React, { useEffect, useState } from "react";
import condominosService from "../../services/condominosService";

const MESES = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];

export default function AniversariantesModal({ show, onClose }) {
  const [mes, setMes] = useState(new Date().getMonth() + 1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show) return;
    setLoading(true);
    condominosService.aniversariantes(mes).then(r => setData(r.data||[])).catch(()=>setData([])).finally(()=>setLoading(false));
  }, [show, mes]);

  if (!show) return null;
  return (
    <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><i className="bi bi-cake2 me-2"/>Aniversariantes</h5>
            <button className="btn-close btn-close-white" onClick={onClose}/>
          </div>
          <div className="modal-body">
            <div className="d-flex align-items-center gap-3 mb-3">
              <label style={{fontSize:13,color:"var(--gray-600)"}}>Mês:</label>
              <select className="form-select form-select-sm" style={{width:160}} value={mes} onChange={e=>setMes(parseInt(e.target.value))}>
                {MESES.map((m,i)=><option key={i} value={i+1}>{m}</option>)}
              </select>
              <span style={{fontSize:12,color:"var(--gray-500)"}}>{data.length} aniversariante(s)</span>
            </div>
            <div className="alert alert-info py-2" style={{fontSize:12}}>
              <i className="bi bi-info-circle me-2"/>
              Felicitações automáticas por e-mail são enviadas todos os dias às 09:00 (apenas para quem optou).
            </div>
            {loading ? <div className="text-center py-3"><span className="spinner-border spinner-border-sm me-2"/>Carregando...</div>
              : data.length === 0 ? <p className="text-center text-muted py-3">Nenhum aniversariante neste mês.</p>
              : <table className="table table-custom table-sm">
                  <thead><tr><th>Dia</th><th>Nome</th><th>Contato</th><th>Último envio</th></tr></thead>
                  <tbody>
                    {data.map(a => {
                      const isHoje = a.dia === new Date().getDate() && a.mes === new Date().getMonth()+1;
                      return (
                        <tr key={a.id} style={{background: isHoje ? "#FEF9C3" : ""}}>
                          <td><strong>{String(a.dia).padStart(2,"0")}/{String(a.mes).padStart(2,"0")}</strong>{isHoje && <span className="badge bg-warning text-dark ms-2" style={{fontSize:9}}>HOJE</span>}</td>
                          <td>{a.nmCompleto}</td>
                          <td style={{fontSize:12}}>
                            {a.email && <div><i className="bi bi-envelope me-1 text-primary"/>{a.email}</div>}
                            {(a.nrWhatsApp||a.celular) && <div style={{color:"var(--gray-500)"}}><i className="bi bi-whatsapp me-1" style={{color:"#25D366"}}/>{a.nrWhatsApp||a.celular}</div>}
                          </td>
                          <td style={{fontSize:12,color:"var(--gray-500)"}}>{a.ultimoEnvio ? new Date(a.ultimoEnvio).toLocaleDateString("pt-BR") : "—"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
            }
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
}
